import {
    Container,
    MessageReference,
    MessageResponse
} from './styled';
import {
    Audio,
    Document,
    Image,
    Location,
    Text,
    Video,
    Sticker
} from '..';

export function Response({ children, message }) {

    const { documento_contexto } = message;

    if (!documento_contexto) {
        return children;
    }


    const verificationType = () => {
        const { type } = message;
        if (type !== 'text' && type !== 'template') {
            if (message?.type === 'audio'
                || message?.type === 'voice'
                || message?.type === 'location'
            ) {
                return 'msgAVL'
            }
            return 'msgM'
        }
    }

    return (
        <Container>
            <MessageReference 
                isUserSystem={documento_contexto?.user_system}
                className={`w-${message.type}`}
            >
                {documento_contexto.type === 'text' &&
                    (<Text
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto.type === 'image' &&
                    (<Image
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto.type === 'template' &&
                    (<Text
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto.type === 'voice' &&
                    (<Audio
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto.type === 'audio' &&
                    (<Audio
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto.type === 'video' &&
                    (<Video
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto.type === 'location' &&
                    (<Location
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto.type === 'document' &&
                    (<Document
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
                {documento_contexto?.type === 'sticker' &&
                    (<Sticker
                        className={"refMs"}
                        message={documento_contexto}
                    />)
                }
            </MessageReference>
            <MessageResponse>
                {children}
            </MessageResponse>
        </Container>
    );
}